import { CmsBanner, CmsBannerType } from '../../../../common/cms-banner';
import { ContentWrapper } from '../../../../common/content-wrapper';
import { useStyles } from './primary-banner.styles';
import { useGetBanners } from '../../../../../hooks/use-get-banners';

export const PrimaryBanner = (): JSX.Element | null => {
  const classes = useStyles();

  const { isBanner, url, pwaCallToActionLink } = useGetBanners(CmsBannerType.userWithoutVouchers);

  return (
    <>
      {isBanner && (
        <section className={classes.root}>
          <ContentWrapper>
            <CmsBanner
              url={url}
              pwaCallToActionLink={pwaCallToActionLink}
            />
          </ContentWrapper>
        </section>
      )}
    </>
  );
};
